module.exports = __webpack_public_path__ + "static/media/map-mark.7c4ceffa.png";